"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseApiService_1 = require("../apiServices/baseApiService/BaseApiService");
var Url_1 = require("./Url");
var string_format_1 = tslib_1.__importDefault(require("string-format"));
var FunctionTypeLibrary = /** @class */ (function () {
    function FunctionTypeLibrary() {
    }
    FunctionTypeLibrary.createLibrary = function (libraryData, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = string_format_1.default(Url_1.url.CreateLiraryUrl, "" + withIPProtection);
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, libraryData)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.addFunctionsToNewLibrary = function (libraryInfo, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.AddFunctionsToNewLibraryUrl + "?withIPProtection=" + withIPProtection;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, libraryInfo)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.addFunctionsToExistingLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.AddFunctionsToExistingLibraryUrl + "?withIPProtection=" + withIPProtection;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, libraryDetails)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.RemoveFunctionsFromLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.RemoveFunctionsFromLibraryUrl + "?withIPProtection=" + withIPProtection;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, libraryDetails)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.DeleteLibrary = function (libraryId, libraryVersion, encryptedPassword, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            libraryId: libraryId, libraryVersion: libraryVersion, encryptedPassword: encryptedPassword
                        };
                        url = Url_1.url.DeleteLibraryUrl + "?withIPProtection=" + withIPProtection;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.DeleteLibraryNew = function (libraryId, libraryVersion, encryptedPassword, withIPProtection, deleteFunctions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            libraryId: libraryId, libraryVersion: libraryVersion, encryptedPassword: encryptedPassword
                        };
                        url = Url_1.url.DeleteLibraryUrlNew + "?withIPProtection=" + withIPProtection + "&deleteFunctions=" + deleteFunctions;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.GetLibraryNodes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.GetLibraryNodes;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.GetMutuallyExclusiveFunctionTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.GetMutuallyExclusiveFunctionTypes;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.GetExportableFunctions = function (exportableInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BaseApiService_1.BaseApiService.post(Url_1.url.ExportFunctions, exportableInfo)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.GetExportableTypes = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.ExportTypes;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, models)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.ImportFunctionTypes = function (importInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.ImportFunctionTypes;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, importInfo)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.ImportFunctionsWithLibrary = function (libraryInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = string_format_1.default(Url_1.url.ImportFunctionsWithLibraryUrl);
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, libraryInfo)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.ValidateLibImport = function (importInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.ValidateLibImportUrl;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, importInfo)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.ValidateLibImportWithLibrary = function (libraryInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = string_format_1.default(Url_1.url.ValidateLibImportWithLibraryUrl);
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, libraryInfo)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.ImportTypes = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.ImportTypes;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, models)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.ValidateTypeImport = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.ValidateTypeImportUrl;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, models)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.GetDecryptedFunctionType = function (libraryId, libraryVersion, encryptedPassword, functionTypeDetails) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            libraryId: libraryId, libraryVersion: libraryVersion, encryptedPassword: encryptedPassword, functionTypeDetails: functionTypeDetails
                        };
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(Url_1.url.GetDecryptedFunctionType, payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FunctionTypeLibrary.UpdateIPProtectedFunctionType = function (libraryId, libraryVersion, encryptedPassword, functionTypeDetails) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            libraryId: libraryId, libraryVersion: libraryVersion, encryptedPassword: encryptedPassword, functionTypeDetails: functionTypeDetails
                        };
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(Url_1.url.UpdateIPProtectedFunctionType, payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FunctionTypeLibrary.GetLibraryReferencedFunctions = function (functionTypes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BaseApiService_1.BaseApiService.post(Url_1.url.GetLibraryReferencedFunctions, functionTypes)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FunctionTypeLibrary.GetFunctionTypeWithEncryptionStatus = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = string_format_1.default(Url_1.url.GetFunctionTypeWithEncryptionStatus, modelId, typeId, version);
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.GetTypeLatestFunctionDataWithEncryption = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = string_format_1.default(Url_1.url.GetTypeLatestFunctionDataWithEncryption, modelId, typeId, version);
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.ConvertToIPProtectedLibrary = function (libraryId, libraryVersion, encryptedPassword) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = { libraryId: libraryId, libraryVersion: libraryVersion, encryptedPassword: encryptedPassword };
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(Url_1.url.ConvertToIPProtectedLibrary, payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FunctionTypeLibrary.CreateAndAssociateFunctionToLib = function (libraryId, libraryVersion, encryptedPassword, functionTypeDetails) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = { libraryId: libraryId, libraryVersion: libraryVersion, encryptedPassword: encryptedPassword, functionTypeDetails: functionTypeDetails };
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(Url_1.url.CreateAndAssociateFunctionToLib, payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FunctionTypeLibrary.ChangeLibraryPassword = function (libraryDataExtended, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.ChangeLibraryPasswordUrl + "?withIPProtection=" + withIPProtection;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, libraryDataExtended)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.UnlockLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.UnlockLibraryUrl + "?withIPProtection=" + withIPProtection;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, libraryDetails)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.deleteEncryptedFunctionType = function (libraryId, libraryVersion, encryptedPassword, modelId, typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, data, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.DeleteEncryptedFunctionType;
                        data = {
                            "libraryId": libraryId,
                            "libraryVersion": libraryVersion,
                            "encryptedPassword": encryptedPassword,
                            "modelId": modelId,
                            "typeId": typeId
                        };
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.renameLibrary = function (libraryId, libraryVersion, encryptedPassword, name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, data, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.RenameLibrary;
                        data = {
                            "libraryId": libraryId,
                            "libraryVersion": libraryVersion,
                            "encryptedPassword": encryptedPassword,
                            "name": name
                        };
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    FunctionTypeLibrary.verifyLibraryExists = function (name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.VerifyLibraryExists, name);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    FunctionTypeLibrary.getLibraryDetails = function (libraryId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.GetLibraryDetails, libraryId);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    return FunctionTypeLibrary;
}());
exports.FunctionTypeLibrary = FunctionTypeLibrary;
//# sourceMappingURL=FunctionTypeLibrary.js.map